/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BulkUpdateTaskStatus } from '@gh/builder-shared-data';
import { DateTimeTypes, getRouteInitData } from '@gh/common-shared';
import { buildDateTimeColumn, LayoutBasedGridDefinition } from '@gh/core-ui-grid';
import { ColDef, GridOptions } from 'ag-grid-community';
import { assign } from 'lodash';
import { ButlListItem } from '../../resources/butl.model';

@Injectable()
export class ButlGridDefinition extends LayoutBasedGridDefinition {
  constructor(private route: ActivatedRoute) {
    super();
    const { bulkUpdateTaskType } = getRouteInitData(route);

    assign(this, { bulkUpdateTaskType });
  }

  buildColumnDefs(): Hash<ColDef> {
    return {
      status: {
        cellClass: ({ data }: { data: ButlListItem }) => ({
          [BulkUpdateTaskStatus.Ready]: 'ready-status',
          [BulkUpdateTaskStatus.Processing]: 'processing-status',
          [BulkUpdateTaskStatus.Complete]: 'complete-status',
          [BulkUpdateTaskStatus.Error]: 'error-status',
        }[data.statusValue || '']),
      },
      addedDate: buildDateTimeColumn(DateTimeTypes.Timestamp),
      updatedDate: buildDateTimeColumn(DateTimeTypes.Timestamp),
    };
  }

  buildGridOptions(): GridOptions {
    return { getRowNodeId: (data: ButlListItem) => data.id };
  }
}
